import './Graph.css';
import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import demoImage from "../../assets/simple_RO_diagram.png";
import { getDiagram } from "../../services/graph.service"; 

export default function Graph() {
  const [ graphImage, setGraphImage ] = useState(null)
  const [ tryAgain, setTryAgain ] = useState(true)
  const [ isOpen, setIsOpen ] = useState(false)  // Modal state
  let params = useParams();
    useEffect(() => {
      
      getDiagram(params.id)
      .then(response => {
      if (response.status === 200) {
          response.blob()
          .then((data)=>{
            if(data.size > 0) {
              setGraphImage(URL.createObjectURL(data))
            }
            else {
              if (tryAgain) setTryAgain(false)
            }
          }).catch((err)=>{
              console.error("error fetching diagram: ",err)
          })
      }
      else {
          console.error("error fetching diagram: ",response.statusText)
      }
      })

    },[tryAgain])

    const noImage = () => {
      return <h1 style={{marginTop:'50px'}}>No Diagram Found</h1>
    }

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

    // Handle keyboard events
    useEffect(() => {
      const handleKeyDown = (event) => {
        if (event.key === 'Escape' && isOpen) {
          closeModal();
        }
      };

      if (isOpen) {
        document.addEventListener('keydown', handleKeyDown);
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'unset';
      }

      return () => {
        document.removeEventListener('keydown', handleKeyDown);
        document.body.style.overflow = 'unset';
      };
    }, [isOpen]);
    return (
      <div id="Graph">
        {graphImage ? (
          <>
            <img 
              src={graphImage} 
              alt="flowsheet"
              onClick={openModal}
              style={{ cursor: 'pointer' }}
              title="Click to view larger"
            />
            
            {/* Modal */}
            {isOpen && (
              <div 
                style={{
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  background: 'rgba(0, 0, 0, 0.8)',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  zIndex: 9999,
                  cursor: 'pointer'
                }}
                onClick={closeModal}
              >
                <div 
                  className="modal-scrollable"
                  style={{
                    position: 'relative',
                    maxWidth: '50vw',
                    maxHeight: '50vh',
                    background: 'white',
                    borderRadius: '8px',
                    overflow: 'auto',
                    cursor: 'default',
                    scrollbarWidth: 'thin',
                    scrollbarColor: 'rgba(0, 0, 0, 0.3) transparent'
                  }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <img
                    src={graphImage}
                    alt="flowsheet"
                    style={{
                      width: '100%',
                      height: 'auto',
                      display: 'block'
                    }}
                  />
                  
                  {/* Close button */}
                  <button
                    onClick={closeModal}
                    style={{
                      position: 'absolute',
                      top: '10px',
                      right: '10px',
                      background: 'rgba(0, 0, 0, 0.7)',
                      color: 'white',
                      border: 'none',
                      borderRadius: '50%',
                      width: '40px',
                      height: '40px',
                      fontSize: '20px',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                    title="Close (ESC)"
                  >
                    ×
                  </button>
                </div>
              </div>
            )}
          </>
        ) : (
          noImage()
        )}
      </div>
    );

}
